import { useContext } from 'react'

// context
import { AppContext } from '../../../../App'

// components
import DataTable from '../../../data-table/data-table'
import Tag from '../../../tag/tag'

const AccidentDetails = (): JSX.Element => {
	const appContext = useContext(AppContext)
	const report = appContext?.biomechanicalReport

	return (
		<DataTable
			headers={[
				{
					key: 'head',
					label: 'Accident Details',
					width: '50%',
				},
				{ key: 'data', label: '', width: '50%' },
			]}
			rows={[
				{
					head: { content: 'Area of Impact' },
					data: {
						content: report?.areaOfImpact,
					},
				},
				{
					head: { content: 'Impact Severity' },
					data: {
						content: (
							<Tag
								theme={report?.impactSeverity.toLocaleLowerCase()}
								label={report?.impactSeverity || ''}
							/>
						),
					},
				},
				{
					head: { content: 'Claimant Position' },
					data: {
						content: report?.claimantPosition,
					},
				},
				{
					head: { content: 'Seatbelt Worn' },
					data: {
						content: report?.seatbelt,
					},
				},
				{
					head: { content: 'Airbag Deployed' },
					data: {
						content: report?.airbag,
					},
				},
			]}
		/>
	)
}

export default AccidentDetails
